import React, { Component } from 'react';
import SearchModal from "../SearchModal/SearchModal";

class SearchButton extends Component {

  state = {
    showModal: false,
  };

  handleCloseClick = (event) => {
    this.setState({ showModal: false });
    event.preventDefault();
  };

  handleButtonClick = (event) => {
    this.setState({ showModal: true });
    event.preventDefault();
  };

  render() {
    return (
      <div>
        <SearchModal index={ this.props.index } visible={ this.state.showModal } onClickClose={ this.handleCloseClick } />
        <button className="site-action-button site-action-button--search" onClick={ this.handleButtonClick }>
          Search
        </button>
      </div>
    );
  }
}

export default SearchButton;
